export default __webpack_public_path__ + "77a3c9247d0f20896e6c04c7b9f25e62.woff2";